const TONES = {
  Draft: "neutral",
  Submitted: "info",
  "Manager Review": "info",
  "Changes Requested": "warning",
  Approved: "success",
  "In Progress": "primary",
  Completed: "success",
  Closed: "neutral",
  "Not Started": "neutral",
  "Pending Approval": "info",
  Resolved: "success", // [NEW] reporting resolution queue
  Dismissed: "neutral", // [NEW] reporting resolution queue
  "Awaiting Assessments": "neutral",
  "Pending HR Review": "warning",
  Finalized: "success",
  Active: "success",
  Inactive: "warning",
  Exited: "neutral",
  Assigned: "neutral",
  "Self Assessed": "info",
  Reviewed: "success",
  open: "success",
  upcoming: "neutral",
  closed: "neutral",
  Draft_cycle: "neutral",
  High: "danger",
  Medium: "warning",
  Low: "neutral",
};

const LABELS = { open: "Open", upcoming: "Upcoming", closed: "Closed" };

export default function StatusBadge({ status, tone, children, dot = true }) {
  const resolved = tone || TONES[status] || "neutral";
  return (
    <span className={`badge badge-${resolved}`}>
      {dot && <span className="badge-dot" aria-hidden="true" />}
      {children || LABELS[status] || status}
    </span>
  );
}
